import { useEffect } from 'react';

import { Checkbox } from '@chakra-ui/react';

import { useAppDispatch } from 'hooks';

import SharedMessage from '../Message/SharedMessage';

import useFormBinderDisabled from 'hooks/useFormBinderDisabled';

import { SharedCheckBoxInputProps } from './CheckBoxInput.types';

const SharedCheckBoxInput = ({
  section,
  formStateKey,
  formActions,
  message,
  children,
  disabled = false,
  required,
  label,
  isChecked,
  ...rest
}: SharedCheckBoxInputProps) => {
  const dispatch = useAppDispatch();
  const isDisabled = useFormBinderDisabled(formStateKey, disabled);

  useEffect(() => {
    if (!required) return;

    if (!isChecked) {
      dispatch(formActions.addMissingMandatoryField({ name: label, section }));
    } else {
      dispatch(formActions.removeMissingMandatoryField(label));
    }
  }, [required, isChecked, label, dispatch, formActions, section]);

  return (
    <>
      <Checkbox
        {...rest}
        disabled={isDisabled}
        isChecked={isChecked}
        id={label}
      >
        {children}
      </Checkbox>
      {message && (
        <SharedMessage
          {...message}
          section={section}
          formStateKey={formStateKey}
          formActions={formActions}
        />
      )}
    </>
  );
};

export default SharedCheckBoxInput;
